export default __webpack_public_path__ + "static/7contenido_blogxpay-afba110e55b5489dd1a0a0a49ec65bb0.png";